import { render, staticRenderFns } from "./DiseaseDirection.vue?vue&type=template&id=81269b08&scoped=true"
import script from "./DiseaseDirection.vue?vue&type=script&lang=js"
export * from "./DiseaseDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81269b08",
  null
  
)

export default component.exports